import React, { useContext } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";

const useStyles = makeStyles({
  title: {
    padding: "0px"
  },
  closeButton: {
    position: 'absolute',
    right: 1,
    top: 1
  },
  paperFullWidth: {
    width: 'calc(100% - 20px)'
  },
  paper: {
    // height: '100%',
    margin: '10px'
  },
  root: {
    // height: '100%'
    marginBottom: "0px",
    "line-height": 0,
  },
  paperScrollPaper: {
    "max-height": "calc(100% - 20px)"
  },
  dialogContent: {
    "overflow-y": "unset",
    "padding": "7px",
    "line-height": 0,
  },
  dialogActions: {
    padding: "0px",
  }
});

const CampaignDialog = (props) => {
  const classes = useStyles();
  // const [open, setOpen] = React.useState(false);
  const history = useHistory();

  const handleClose = () => {
    props.setOpen(false);
  };

  const handleNext = () => {
   
  };

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={true}
      maxWidth={"md"}
      className="fuckniasing"
      classes={{ paper: classes.paper, paperScrollPaper: classes.paperScrollPaper, paperFullWidth: classes.paperFullWidth }}
    >
      <DialogTitle classes={{root: classes.title}} id="alert-dialog-title">
        {/* Wakalah Contract */}
        <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent classes={{ root: classes.dialogContent }}>
        {/* <DialogContentText classes={{ root: classes.root }} id="alert-dialog-description"> */}
        <a href="https://aspirasi-insure-assets.s3-ap-southeast-1.amazonaws.com/Aspirasi+Insure/TC-for-Aspirasi-Boost-Campaign-13Feb.pdf" target="_blank">
          <img style={{width:"100%"}}  src="/images/boost-campaign.png"></img>
        </a>
        
        {/* </DialogContentText> */}
      </DialogContent>
      <DialogActions classes={{root : classes.dialogActions}}>
        {/* <Button onClick={handleClose} color="primary">
          Close
        </Button>
        <Button onClick={handleNext} color="primary" autoFocus>
          Agree
        </Button> */}
      </DialogActions>
    </Dialog>
  );
}

export default CampaignDialog;